import React, { useEffect, useState } from "react";

export default function CustomCursor() {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const moveCursor = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("mousemove", moveCursor);

    let animationFrame;

    const smoothCursor = () => {
      // Smooth interpolation
      setCursorPos((prev) => {
        const dx = position.x - prev.x;
        const dy = position.y - prev.y;

        return {
          x: prev.x + dx * 0.15, // smoothness factor (0.1 → slower, 0.3 → faster)
          y: prev.y + dy * 0.15,
        };
      });

      animationFrame = requestAnimationFrame(smoothCursor);
    };

    smoothCursor();

    return () => {
      window.removeEventListener("mousemove", moveCursor);
      cancelAnimationFrame(animationFrame);
    };
  }, [position]);

  return (
    <div
      className="custom-cursor"
      style={{
        left: `${cursorPos.x}px`,
        top: `${cursorPos.y}px`,
      }}
    ></div>
  );
}
